import { ISagaModule } from 'redux-dynamic-modules-saga'

import { FeatureState } from './models'
import FeatureActions from './Store/actions'
import { featuresReducer } from './Store/reducer'
import { FeaturesSagas } from './Store/sagas'

export function getFeaturesModule() {
  const featuresModule: ISagaModule<{ features: FeatureState }> = {
    id: 'features',
    initialActions: [FeatureActions.getFeatures()],
    reducerMap: {
      features: featuresReducer
    },
    sagas: [FeaturesSagas.run]
  }
  return featuresModule
}
